import React, { Component } from 'react'
import css from './style.module.css'

export default class FormGroup extends Component {

    render() {
        const { children, className, ...props } = this.props
        return (
            <div
                ref='div'
                className={[css.formGroup, className ? className : null].join(' ')} { ...props }>
                {children}
            </div>
        )
    }
    
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Form/FormGroup.js